import { debounceTime } from "rxjs";
import { BaseComponent } from "./base-component.class";


export abstract class BaseTableComponent extends BaseComponent{

  perPage:number=10;
  pageSizeOptions = [10,20,50];
  currentPage = 0;
  totalRecords = 0;

  updateQueryParam(param:any): void {
    this.currentPage = Number(param.get('page')) || 0;
    this.perPage = Number(param.get('size')) || 10;
  }


  onPageEvent(event: any, path:string, extras = {}) {
    this.perPage=event.pageSize || 10;
    this.currentPage=event.pageIndex;
    const queryParam = {_t: new Date().getTime(), ...extras,  page: this.currentPage, size: this.perPage, };
    this.router.navigate([path], { queryParams: queryParam });
    }


  setTotal(count: number): void {
    this.totalRecords = count;
  }


}
